import merge from "lodash/merge";
/**
 * @deprecated Please use mergeSlotProps from `/lab`
 */
export const mergeSlotProps = (baseSlotsProps, overridingSlotsProps) => merge(baseSlotsProps, overridingSlotsProps);
/**
 * @deprecated Please use slotsWithDefault from `/lab`
 */
// biome-ignore lint/complexity/noBannedTypes: <explanation>
export function slotsWithDefault(req, slots) {
    return { ...req, ...slots };
}
/**
 * @deprecated Please use SlotsProvider from `/lab`
 */
// biome-ignore lint/complexity/noBannedTypes: <explanation>
export const SlotsInjector = ({ props, children, }) => {
    return children({
        ...props,
        getSlotsWithDefaults: slotsWithDefault,
    });
};
//# sourceMappingURL=slots.js.map